import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { ImportTariffModel } from '../../../core/models/tariff.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'

import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service';
import { ProposalItemService } from '../../../core/services/proposal/proposal-item/proposal-item.service';
import { ItinerariesService } from '../../../core/services/itineraries/itineraries/itiniraries.service';
import { ServiceAdditionalProposalService } from '../../../core/services/service/service-additional-proposal/service-additional-proposal.service';

import { emailValidator } from '../../../shared/utils/email_validator'
import {
  CleanFileName,
  downloadBase64File,
} from '../../../shared/utils/download_base64'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatListModule } from '@angular/material/list'
import { LOGO_BASE64 } from '../../../../assets/images/logo/logo-base64'
import { BAGS_BASE64 } from '../../../../assets/images/logo/bags-base64'

import * as pdfMakeLib from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { forkJoin, map, of, switchMap, from, toArray, concatMap, timer } from 'rxjs'

const pdfMake = pdfMakeLib as any;
pdfMake.vfs = (pdfFonts as any).pdfMake ? (pdfFonts as any).pdfMake.vfs : (pdfFonts as any).vfs;


@Component({
  selector: 'modal-download-proposal',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDivider,
    MatProgressBar,
    MatListModule,
  ],
  templateUrl: './modal-download-proposal.component.html',
  styleUrl: './modal-download-proposal.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalDownloadProposalComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private commissionDividerService: CommissionDividerService,
    private proposalItemService: ProposalItemService,
    private itinerariesService: ItinerariesService,
    private serviceAdditionalProposalService: ServiceAdditionalProposalService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalDownloadProposalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.id) {
      this.idProposal = data.id
    }
    if (data.item) {
      this.item = data.item
    }
  }

  item: any = {}
  idProposal: number = -1
  loading: boolean = false

  ngOnInit(): void { }

  close() {
    this.dialogRef.close()
  }

  // formatacoes
  private formatCurrency(value: any): string {
    const amount = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(amount)) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(amount);
  }

  private formatPhone(phone: any): string {
    if (!phone) return '';

    const cleaned = ('' + phone).replace(/\D/g, '');

    if (cleaned.length === 11) {
      return cleaned.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    }

    if (cleaned.length === 10) {
      return cleaned.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    }

    return phone;
  }

  private formatAddress(itinerario: any): string {
    if (!itinerario) return 'Endereço não informado';
    const { logradouro, bairro, cidade, estado, cep } = itinerario;
    return `${logradouro}, ${bairro}, ${cidade}, ${estado}, ${cep}`;
  }

  private getAddressText(point: any): string {
    if (!point) return 'Endereço não informado';
    const data = point.endereco || point;
    const local = point.localParada || data.localParada;
    if (local && typeof local === 'string' && local.toLowerCase().includes('aeroporto')) {
      return local;
    }
    return this.formatAddress(data);
  }

  private formatOnlyDate = (date: any) => {
    if (!date) return '';
    if (typeof date === 'string') {
      if (date.includes('T')) {
        const splitted = date.split('T')[0].split('-');
        if (splitted.length === 3) return `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
      }
      if (date.includes('-')) {
        const splitted = date.split(' ')[0].split('-');
        if (splitted.length === 3 && splitted[0].length === 4) return `${splitted[2]}/${splitted[1]}/${splitted[0]}`;
      }
      const match = date.match(/^(\d{2}\/\d{2}\/\d{4})/);
      if (match) {
        return match[1];
      }
    }
    return date;
  };

  downloadPdf() {
    this.loading = true;

    this.proposalClientService.getProposalClientbyId(this.idProposal).pipe(

      // Primeiro switchMap: assim que trouxer a proposta base, engatilha outras requisições
      switchMap((proposalResponse: any) => {
        const proposalData = proposalResponse.data;
        // Pegue o ID do cliente dentro dos dados da proposta:
        const clienteId = proposalData.clienteId;

        // Monta os Observables que podem ser resolvidos "ao mesmo tempo" (em paralelo)
        const divisor$ = this.commissionDividerService.getCommissionDividerbyClientId(clienteId);
        const itensProposta$ = this.proposalItemService.getProposalItembyProposalId(this.idProposal);
        const servicosAdicionais$ = this.serviceAdditionalProposalService.listServiceAdditionalByProposalId(this.idProposal);

        // forkJoin junta todas as chamadas e só libera p/ próxima etapa quando TODAS terminarem
        return forkJoin({
          proposal: of(proposalResponse), // Passamos a proposta adiante convertendo em observable usando 'of'
          divisor: divisor$,
          itemProposta: itensProposta$,
          servicosAdicionais: servicosAdicionais$
        });
      }),

      // Segundo switchMap: agora temos dados do Item da Proposta para chamar a Parada do Itinerário
      switchMap((results: any) => {
        // Garantimos o acesso ao array da resposta
        const itensPropostaArray = results.itemProposta.data;

        if (!itensPropostaArray || itensPropostaArray.length === 0) {
          return of({
            ...results,
            itensComItinerarios: []
          });
        }

        const pageNumber = 1;
        const pageSize = 1000; // Como o pdf precisa do dado todo, pegue um pageSize bem alto pra ignorar paginação

        return from(itensPropostaArray).pipe(
          concatMap((item: any, index: number) => {
            // Chama uma de cada vez, com atraso de 300ms entre as chamadas (a primeira sai imediatamente)
            return timer(index === 0 ? 0 : 300).pipe(
              switchMap(() =>
                this.itinerariesService.listPagedItinerariesStopByItemPropose(item.id, pageNumber, pageSize).pipe(
                  map((itinerarioResponse: any) => ({
                    index,
                    data: {
                      ...item, // Espalha as propriedades do item atual (incluindo "origem" e "destino")
                      paradas: itinerarioResponse.data || itinerarioResponse // O array de paradas desse item exato
                    }
                  }))
                )
              )
            );
          }),
          toArray(),
          map((res: any[]) => res.sort((a, b) => a.index - b.index).map(x => x.data)),
          map((listaFinalDeItens) => {
            // Pega o resultado total pronto e entrega pro Subscrible (agora o seu array está montado!)
            return {
              ...results, // Aqui mantemos os dados lá de trás (proposal, divisor) intactos
              itensComItinerarios: listaFinalDeItens
            };
          })
        );
      })
    )
      .subscribe({
        next: (dadosCompletos: any) => {
          // requisições
          const proposalData = dadosCompletos.proposal.data;
          const divisoresData = dadosCompletos.divisor.data;
          const itensPropostaData = dadosCompletos.itemProposta.data;
          const itinerarioData = dadosCompletos.itensComItinerarios;
          const servicosAdicionaisData = dadosCompletos.servicosAdicionais.data;

          const totalVeiculos = (itinerarioData || []).reduce((acc: number, item: any) => acc + (Number(item.quantidadeVeiculos) || 0), 0);

          // monta o body dos transportes
          // monta o body dos transportes numa tabela mestre
          const transportMasterBody: any[][] = [];

          // HEADER ROW
          transportMasterBody.push([
            {
              table: {
                widths: [14, 95, '*', 55, 68, 50, 52, 52, 52, 50, 50],
                body: [
                  // LINHA DE CABEÇALHO (VERDE)
                  [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Data e Hora:', style: 'tableHeader' },
                    { text: 'Descrição dos Serviços:', style: 'tableHeader' },
                    { text: 'Quant. de Passageiros', style: 'tableHeader' },
                    { text: 'Tipo de Serviço:', style: 'tableHeader' },
                    { text: 'Veículos:', style: 'tableHeader' },
                    { text: 'Motorista:', style: 'tableHeader' },
                    { text: 'Valor Unitário:', style: 'tableHeader' },
                    { text: 'Quantidade Veículos:', style: 'tableHeader' },
                    { text: 'Valor Total SEM TAXA:', style: 'tableHeader' },
                    { text: 'Valor Total COM TAXA:', style: 'tableHeader' },
                  ]
                ]
              },
              layout: {
                hLineColor: () => '#cccccc',
                vLineColor: () => '#cccccc',
                hLineWidth: () => 0.5,
                vLineWidth: () => 0.5,
              },
              margin: [0, 0, 0, 0]
            }
          ]);

          if (itinerarioData && itinerarioData.length > 0) {
            const grupos = this.groupConsecutiveItems(itinerarioData);
            let itemIndex = 1;

            grupos.forEach((grupo) => {
              const groupSize = grupo.length;
              const groupRows: any[] = [];

              // Cálculo de alturas para centralização vertical
              const itStackForHeight = this.buildItineraryStack(grupo[0]);
              const estTotalHeight = itStackForHeight.length * 10; // Estimativa para fonte tamanho 7
              const rowHeight = Math.max(18, estTotalHeight / groupSize);
              const totalGroupHeight = rowHeight * groupSize;

              grupo.forEach((item: any, index: number) => {
                const isFirst = index === 0;

                let horaFormatar = item.horaInicio;
                if (!horaFormatar && typeof item.dataInicio === 'string') {
                  const matchTime = item.dataInicio.match(/^\d{2}\/\d{2}\/\d{4}\s?(\d{2}:\d{2}(:\d{2})?)/);
                  if (matchTime) {
                    horaFormatar = matchTime[1];
                  }
                }
                const dataFormatada = this.formatOnlyDate(item.dataInicio);

                let horaFimFormatar = item.horaFinal;
                if (!horaFimFormatar && typeof item.dataFinal === 'string') {
                  const matchTimeFim = item.dataFinal.match(/^\d{2}\/\d{2}\/\d{4}\s?(\d{2}:\d{2}(:\d{2})?)/);
                  if (matchTimeFim) {
                    horaFimFormatar = matchTimeFim[1];
                  }
                }
                const dataFimFormatada = this.formatOnlyDate(item.dataFinal);

                const strInicio = horaFormatar ? `${dataFormatada} ${horaFormatar}` : dataFormatada;
                const strFim = dataFimFormatada ? (horaFimFormatar ? `${dataFimFormatada} ${horaFimFormatar}` : dataFimFormatada) : '';

                const pass = (item.quantidadePassageiros).toString();
                const tipoSrv = (item.descricaoTipoServico || '') + (item.descricaoServico ? ' - ' + item.descricaoServico : '');
                const veic = item.descricaoTipoVeiculo || '';
                const motorista = item.descricaoTipoMotorista || '';
                const valUni = item.valorUnitario;
                const qtdVeic = item.quantidadeVeiculos;
                const valFinal = item.valorVenda;
                const valTaxa = item.valorComTaxa;

                // Preparamos a stack de itinerários para a coluna "Descrição"
                const itineraryStack = this.buildItineraryStack(item);

                // Margens para centralização (Estimamos 11 unidades por linha de fonte 9)
                const dtHoraLines = strFim ? 2 : 1;
                const vMarginDtHora = Math.max(0, (totalGroupHeight - (dtHoraLines * 11)) / 2);
                const vMarginStack = Math.max(0, (totalGroupHeight - estTotalHeight) / 2);
                const vMarginGrouped = Math.max(0, (totalGroupHeight - 11) / 2);
                const vMarginIndividual = Math.max(0, (rowHeight - 11) / 2);

                groupRows.push([
                  // # - Sequencial
                  { text: String(itemIndex++), style: 'tableValue', alignment: 'center', margin: [0, vMarginIndividual, 0, 0] },

                  // Data e Hora - Agrupado
                  isFirst ? { stack: strFim ? [strInicio, strFim] : [strInicio], style: 'tableValue', alignment: 'center', rowSpan: groupSize, margin: [0, vMarginDtHora, 0, 0] } : {},

                  // Descrição dos Serviços - Agrupado
                  isFirst ? { stack: itineraryStack, style: 'tableValueWrap', alignment: 'left', margin: [2, vMarginStack + 2, 2, 2], rowSpan: groupSize } : {},

                  // Pax - Individual
                  { text: pass, style: 'tableValue', alignment: 'center', margin: [0, vMarginIndividual, 0, 0] },

                  // Tipo Serviço - Agrupado
                  isFirst ? { text: tipoSrv, style: 'tableValueWrap', alignment: 'center', rowSpan: groupSize, margin: [0, vMarginGrouped, 0, 0] } : {},

                  // Veículos
                  { text: veic, style: 'tableValueWrap', alignment: 'center', margin: [2, vMarginIndividual, 2, 0] },

                  // Motorista - Agrupado
                  isFirst ? { text: motorista, style: 'tableValue', alignment: 'center', rowSpan: groupSize, margin: [0, vMarginGrouped, 0, 0] } : {},

                  // Valor Unitário
                  { text: this.formatCurrency(valUni), style: 'tableValue', alignment: 'center', margin: [2, vMarginIndividual, 2, 0] },

                  // Quantidade
                  { text: String(qtdVeic), style: 'tableValue', alignment: 'center', margin: [0, vMarginIndividual, 0, 0] },

                  // Total SEM TAXA
                  { text: this.formatCurrency(valFinal), style: 'tableValue', alignment: 'center', margin: [2, vMarginIndividual, 2, 0] },

                  // Total COM TAXA
                  { text: this.formatCurrency(valTaxa), style: 'tableValue', alignment: 'center', margin: [2, vMarginIndividual, 2, 0] }
                ]);
              });

              if (grupo[0].mostrarObsPdf === 'S' && grupo[0].observacao) {
                groupRows.push([
                  {
                    text: 'Obs: ' + grupo[0].observacao,
                    colSpan: 11,
                    style: 'tableValueWrap',
                    fillColor: '#f5f5f5', // linha levemente cinza
                    margin: [4, 4, 4, 4],
                    alignment: 'left'
                  },
                  '', '', '', '', '', '', '', '', '', ''
                ]);
              }

              transportMasterBody.push([
                {
                  unbreakable: true, // Impede que o grupo se divida entre páginas
                  table: {
                    widths: [14, 95, '*', 55, 68, 50, 52, 52, 52, 50, 50],
                    body: groupRows,
                    heights: (rowIndex: number) => rowIndex < groupSize ? rowHeight : 15
                  },
                  layout: {
                    hLineColor: () => '#cccccc',
                    vLineColor: () => '#cccccc',
                    hLineWidth: (i: number) => (i === 0) ? 0 : 0.5, // Remove borda superior para colar na tabela anterior
                    vLineWidth: () => 0.5,
                  },
                  margin: [0, 0, 0, 0]
                }
              ]);
            });

            // Adiciona a margem final no último grupo
            transportMasterBody[transportMasterBody.length - 1][0].margin = [0, 0, 0, 15];
          } else {
            transportMasterBody[0][0].margin = [0, 0, 0, 15];
          }

          // monta o body dos adicionais
          let itensAdicionaisContent: any[] = [];

          if (servicosAdicionaisData && servicosAdicionaisData.length > 0) {

            const servicosBody: any[] = [
              // Linha Laranja (Título fundido em 5 colunas com colSpan)
              [
                {
                  text: 'ITENS ADICIONAIS',
                  style: 'mainHeader',
                  colSpan: 5,
                  alignment: 'center',
                  border: [false, false, false, false],
                },
                '', '', '', ''
              ],
              // Linha Verde (Sub-cabeçalho)
              [
                { text: 'Descrição', style: 'tableHeader' }, // Verde claro
                { text: 'Qtd Itens', style: 'tableHeader' },
                { text: 'Valor Unitário', style: 'tableHeader' },
                { text: 'Valor Final', style: 'tableHeader' },
                { text: 'Taxa', style: 'tableHeader' }
              ]
            ];
            // 3. Iteramos inserindo os dados reais recuperados do backend
            servicosAdicionaisData.forEach((item: any) => {
              servicosBody.push([
                // ATENÇÃO: Verifique os nomes das propriedades com a sua API ('descricao', 'quantidade', etc)
                { text: item.descricao, alignment: 'center', style: 'tableValueWrap' },
                { text: (item.quantidade).toString(), alignment: 'center', style: 'tableValueWrap' },
                { text: this.formatCurrency(item.valorUnitario), alignment: 'center', style: 'tableValueWrap' },
                { text: this.formatCurrency(item.valorTotal), alignment: 'center', style: 'tableValueWrap' },
                { text: (item.taxa) + '%', alignment: 'center', style: 'tableValueWrap' }
              ]);
            });
            // 4. Se chegou aqui é porque tem dados, embalamos isso dentro do bloco estrutural do pdfMake
            itensAdicionaisContent = [
              {
                unbreakable: true, // Tenta não quebrar a tabela na troca de página do PDF
                stack: [
                  {
                    table: {
                      widths: ['40%', '15%', '15%', '15%', '15%'], // Proporção da largura de cada coluna
                      body: servicosBody
                    },
                    layout: {
                      hLineColor: () => '#cccccc', // Linhas e bordas como na imagem
                      vLineColor: () => '#cccccc',
                      hLineWidth: () => 0.5,
                      vLineWidth: () => 0.5,
                    },
                    margin: [0, 0, 0, 15] // Espaçamento na base
                  }
                ]
              }
            ];

          }

          let docName = `${proposalData.codigoTg} - ${CleanFileName(proposalData.nomeCliente)} - ${proposalData.nomeSubCliente ? CleanFileName(proposalData.nomeSubCliente) + ' - ' : ''} ${CleanFileName(proposalData.solicitante)}.pdf`

          const documentDefinition: any = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            content: [
              {
                image: LOGO_BASE64,
                width: 150,
                alignment: 'center',
                margin: [0, 0, 0, 20]
              },
              {
                table: {
                  widths: ['*'], // Faz a tabela ocupar 100% da largura
                  body: [
                    [
                      {
                        text: `${proposalData?.codigoTg} - ${proposalData?.nomeEvento}`,
                        style: 'mainHeader',
                      }
                    ]
                  ]
                },

                layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                margin: [0, 0, 0, 15] // Margem inferior para o próximo conteúdo
              },

              // consultor
              {
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `CONSULTOR tg.mob`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    columns: [
                      {
                        width: '40%',
                        stack: [
                          {
                            columns: [
                              { text: 'Consultor:', style: 'label', width: 60 },
                              { text: proposalData?.nomeConsultor, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'E-mail:', style: 'label', width: 60 },
                              { text: proposalData?.solicitanteEmail, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Telefone:', style: 'label', width: 60 },
                              { text: this.formatPhone(proposalData?.solicitanteTelefone), style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          }
                        ]
                      },
                      {
                        width: '60%',
                        stack: [
                          { text: '#Plantão de 24hs para atendimento emergencial por ligações: +55 (11)5564-8700', style: 'emergency' },
                          { text: '#Plantão de 24hs para atendimento emergencial por WhatsApp: +55 (11)91697-7972', style: 'emergency' },
                          { text: '#Plantão de 24hs para atendimento emergencial Internacional: +55 (11)96489-9673', style: 'emergency' }
                        ],
                      }
                    ],
                    margin: [0, 0, 0, 15] // Espaçamento em cima e embaixo da seção
                  },
                ]
              },

              // ORÇAMENTO
              {
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `ORÇAMENTO`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    columns: [
                      {
                        width: '40%',
                        stack: [
                          {
                            columns: [
                              { text: 'Cliente:', style: 'label', width: 60 },
                              { text: proposalData?.nomeCliente, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Evento:', style: 'label', width: 60 },
                              { text: proposalData?.nomeEvento, style: 'value', bold: true }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Data do Evento:', style: 'label', width: 60 },
                              { text: this.formatOnlyDate(proposalData?.dataInicio), style: 'value', bold: true }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Solicitante:', style: 'label', width: 60 },
                              { text: proposalData?.solicitante, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Email Solicitante:', style: 'label', width: 60 },
                              { text: proposalData?.solicitanteEmail, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Telefone Solicitante:', style: 'label', width: 60 },
                              { text: this.formatPhone(proposalData?.solicitanteTelefone), style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          }
                        ]
                      },
                      {
                        width: '60%',
                        stack: [
                          {
                            columns: [
                              { text: 'Cod. tg.mob:', style: 'label', width: 60 },
                              { text: proposalData?.codigoTg, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Data Emissão:', style: 'label', width: 60 },
                              { text: proposalData?.dataCriacao, style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Taxa Serviço:', style: 'label', width: 60 },
                              { text: divisoresData?.taxa + '%', style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          },
                          {
                            columns: [
                              { text: 'Valor Total:', style: 'label', width: 60 },
                              { text: this.formatCurrency(proposalData?.valorTotal), style: 'value' }
                            ],
                            margin: [0, 0, 0, 5]
                          }
                        ]
                      }
                    ],
                    margin: [0, 0, 0, 15] // Espaçamento em cima e embaixo da seção
                  },
                ]
              },

              // TRANSPORTE
              {
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `TRANSPORTE`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    table: {
                      headerRows: 1, // Repete a primeira linha (cabeçalho) em todas as páginas
                      widths: ['*'],
                      body: transportMasterBody
                    },
                    layout: {
                      hLineWidth: () => 0,
                      vLineWidth: () => 0,
                      paddingLeft: () => 0,
                      paddingRight: () => 0,
                      paddingTop: () => 0,
                      paddingBottom: () => 0,
                    }
                  }
                ]
              },

              ...itensAdicionaisContent,

              // SERVIÇOS MONO
              {
                unbreakable: true,
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `SERVIÇOS MONO`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    table: {
                      // 9 colunas: 'auto' para o texto da esquerda e '*' para distribuir o resto igualmente
                      widths: ['auto', '*', '*', '*', '*', '*', '*', '*', '*'],
                      headerRows: 1,
                      body: [
                        // LINHA DE CABEÇALHO (VERDE)
                        [
                          { text: 'Serviço', style: 'tableHeader' },
                          { text: 'Sedan Executivo', style: 'tableHeader' },
                          { text: 'Sedan Blindado', style: 'tableHeader' },
                          { text: 'Mini Van ou SUV', style: 'tableHeader' },
                          { text: 'Mini Van ou SUV Blindado', style: 'tableHeader' },
                          { text: 'Van Executiva', style: 'tableHeader' },
                          { text: 'Van Executiva Blindado', style: 'tableHeader' },
                          { text: 'Micro-ônibus', style: 'tableHeader' },
                          { text: 'Ônibus', style: 'tableHeader' },
                        ],
                        // LINHA HORA EXTRA
                        [
                          { text: 'Hora Extra', style: 'tableLabel' },
                          { text: 'R$ 130,00', style: 'tableValue' },
                          { text: 'R$ 215,00', style: 'tableValue' },
                          { text: 'R$ 200,00', style: 'tableValue' },
                          { text: 'R$ 310,00', style: 'tableValue' },
                          { text: 'R$ 215,00', style: 'tableValue' },
                          { text: 'R$ 430,00', style: 'tableValue' },
                          { text: 'R$ 310,00', style: 'tableValue' },
                          { text: 'R$ 430,00', style: 'tableValue' },
                        ],
                        // LINHA KM EXTRA
                        [
                          { text: 'Km Extra', style: 'tableLabel' },
                          { text: 'R$ 5,80', style: 'tableValue' },
                          { text: 'R$ 8,60', style: 'tableValue' },
                          { text: 'R$ 8,60', style: 'tableValue' },
                          { text: 'R$ 10,00', style: 'tableValue' },
                          { text: 'R$ 10,00', style: 'tableValue' },
                          { text: 'R$ 13,00', style: 'tableValue' },
                          { text: 'R$ 13,60', style: 'tableValue' },
                          { text: 'R$ 17,20', style: 'tableValue' },
                        ]
                      ]
                    },
                    layout: {
                      hLineColor: () => '#cccccc',
                      vLineColor: () => '#cccccc',
                      hLineWidth: () => 0.5,
                      vLineWidth: () => 0.5,
                    },
                    margin: [0, 0, 0, 15]
                  },
                ]
              },

              // SERVIÇOS BILÍNGUE
              {
                unbreakable: true,
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `SERVIÇOS BILÍNGUE`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    table: {
                      // 9 colunas: 'auto' para o texto da esquerda e '*' para distribuir o resto igualmente
                      widths: ['auto', '*', '*', '*', '*', '*', '*', '*', '*'],
                      headerRows: 1,
                      body: [
                        // LINHA DE CABEÇALHO (VERDE)
                        [
                          { text: 'Serviço', style: 'tableHeader' },
                          { text: 'Sedan Executivo', style: 'tableHeader' },
                          { text: 'Sedan Blindado', style: 'tableHeader' },
                          { text: 'Mini Van ou SUV', style: 'tableHeader' },
                          { text: 'Mini Van ou SUV Blindado', style: 'tableHeader' },
                          { text: 'Van Executiva', style: 'tableHeader' },
                          { text: 'Van Executiva Blindado', style: 'tableHeader' },
                          { text: 'Micro-ônibus', style: 'tableHeader' },
                          { text: 'Ônibus', style: 'tableHeader' },
                        ],
                        // LINHA HORA EXTRA
                        [
                          { text: 'Hora Extra', style: 'tableLabel' },
                          { text: 'R$ 230,00', style: 'tableValue' },
                          { text: 'R$ 370,00', style: 'tableValue' },
                          { text: 'R$ 350,00', style: 'tableValue' },
                          { text: 'R$ 530,00', style: 'tableValue' },
                          { text: 'R$ 380,00', style: 'tableValue' },
                          { text: 'R$ 750,00', style: 'tableValue' },
                          { text: '-', style: 'tableValue' },
                          { text: '-', style: 'tableValue' },
                        ],
                        // LINHA KM EXTRA
                        [
                          { text: 'Km Extra', style: 'tableLabel' },
                          { text: 'R$ 5,80', style: 'tableValue' },
                          { text: 'R$ 8,60', style: 'tableValue' },
                          { text: 'R$ 8,60', style: 'tableValue' },
                          { text: 'R$ 10,00', style: 'tableValue' },
                          { text: 'R$ 10,00', style: 'tableValue' },
                          { text: 'R$ 13,00', style: 'tableValue' },
                          { text: 'R$ 13,60', style: 'tableValue' },
                          { text: 'R$ 17,20', style: 'tableValue' },
                        ]
                      ]
                    },
                    layout: {
                      hLineColor: () => '#cccccc',
                      vLineColor: () => '#cccccc',
                      hLineWidth: () => 0.5,
                      vLineWidth: () => 0.5,
                    },
                    margin: [0, 0, 0, 15]
                  },
                ]
              },

              // ITENS OPCIONAIS RECOMENDADOS
              {
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `ITENS OPCIONAIS RECOMENDADOS`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    table: {
                      widths: ['80%', '20%'],
                      headerRows: 1,
                      body: [
                        [
                          { text: 'Descrição do Item', style: 'tableHeader' },
                          { text: 'Valor', style: 'tableHeader' },
                        ],
                        // ITENS
                        [
                          { text: 'Água 500 ml sem gás', style: 'tableLabel' },
                          { text: 'R$ 10,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador Bilíngue por 05 horas', style: 'tableLabel' },
                          { text: 'R$ 450,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador Bilíngue por 10 horas', style: 'tableLabel' },
                          { text: 'R$ 520,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador Bilíngue por 12 horas', style: 'tableLabel' },
                          { text: 'R$ 650,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador de embarque (Receber o cliente e auxiliá-lo até o embarque)', style: 'tableLabel' },
                          { text: 'R$ 390,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador por 05 horas', style: 'tableLabel' },
                          { text: 'R$ 400,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador por 10 horas', style: 'tableLabel' },
                          { text: 'R$ 450,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Coordenador por 12 horas', style: 'tableLabel' },
                          { text: 'R$ 615,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Receptivo nos aeroportos - Sedan Executivo', style: 'tableLabel' },
                          { text: 'R$ 89,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Receptivo nos aeroportos - SUV - Mini Van - Van Executivo', style: 'tableLabel' },
                          { text: 'R$ 104,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Receptivo nos aeroportos Bilíngue - Sedan Executivo', style: 'tableLabel' },
                          { text: 'R$ 155,00', style: 'tableValue' },
                        ],
                        [
                          { text: 'Receptivo nos aeroportos Bilíngue - SUV - Mini Van - Van Executivo', style: 'tableLabel' },
                          { text: 'R$ 300,00', style: 'tableValue' },
                        ]
                      ]
                    },
                    layout: {
                      hLineColor: () => '#cccccc',
                      vLineColor: () => '#cccccc',
                      hLineWidth: () => 0.5,
                      vLineWidth: () => 0.5,
                    },
                    margin: [0, 0, 0, 15]
                  },
                ]
              },

              // Opções de veículos e bagagem
              {
                unbreakable: true,
                stack: [
                  {
                    table: {
                      widths: ['*'], // Faz a tabela ocupar 100% da largura
                      body: [
                        [
                          {
                            text: `OPÇÕES DE VEÍCULOS E BAGAGEM`,
                            style: 'mainHeader',
                          }
                        ]
                      ]
                    },

                    layout: 'noBorders', // Remove as bordas pretas padrão da tabela
                    margin: [0, 0, 0, 10] // Margem inferior para o próximo conteúdo
                  },
                  {
                    table: {
                      // Definindo larguras fixas para melhor controle visual
                      widths: ['35%', '15%', '15%', '10%', '25%'],
                      headerRows: 1,
                      body: [
                        // CABEÇALHO
                        [
                          { text: 'Veículo', style: 'tableHeader' },
                          { text: 'Bagagem Média', style: 'tableHeader' },
                          { text: 'Bagagem Grande', style: 'tableHeader' },
                          { text: 'Sem Bagagem', style: 'tableHeader' },
                          { text: 'Medidas de Bagagem', style: 'tableHeader' },
                        ],
                        [
                          {
                            stack: [
                              { text: 'Sedans Executivos', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, som, vidros escuros, air bag, cinto \nde segurança e bancos de couro.' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '02 Pax\n03 bagagens médias', style: 'tableValueWrap' },
                          { text: '02 Pax\n02 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '03 Pax', style: 'tableValue' },
                          {
                            image: BAGS_BASE64,
                            width: 170,
                            alignment: 'center',
                            margin: [0, 80, 0, 0],
                            rowSpan: 7
                          }
                        ],
                        [
                          {
                            stack: [
                              { text: 'SUV', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, som, vidros escuros, cinto de \nsegurança, bancos de couro e reclináveis.' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '02 a 04 Pax\n05 bagagens médias', style: 'tableValueWrap' },
                          { text: '02 a 04 Pax\n03 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '02 a 04 Pax', style: 'tableValue' },
                          '' // Célula vazia obrigatória por causa do rowSpan
                        ],
                        [
                          {
                            stack: [
                              { text: 'Mini Van executiva', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, som, vidros escuros, cinto de \nsegurança, bancos de couro e reclináveis.' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '03 a 06 Pax\n06 bagagens médias', style: 'tableValueWrap' },
                          { text: '03 a 06 Pax\n04 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '03 a 06 Pax', style: 'tableValue' },
                          '' // Célula vazia obrigatória por causa do rowSpan
                        ],
                        [
                          {
                            stack: [
                              { text: 'Van executiva 15 Lugares', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, som, vidros escuros, cinto de \nsegurança, bancos de couro e reclináveis.' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '09 Pax\n09 bagagens médias', style: 'tableValueWrap' },
                          { text: '08 Pax\n08 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '13 a 15 Pax', style: 'tableValue' },
                          '' // Célula vazia obrigatória por causa do rowSpan
                        ],
                        [
                          {
                            stack: [
                              { text: 'Van executiva 18 Lugares', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, som, vidros escuros, cinto de \nsegurança, bancos de couro e reclináveis.' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '12 Pax\n12 bagagens médias', style: 'tableValueWrap' },
                          { text: '09 Pax\n09 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '13 a 18 Pax', style: 'tableValue' },
                          '' // Célula vazia obrigatória por causa do rowSpan
                        ],
                        [
                          {
                            stack: [
                              { text: 'Micro-ônibus Executivo', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, TV, DVD, som ambiente, cinto de\nsegurança e reclináveis. (Toalete mediante\ndisponibilidade)' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '18 Pax\n18 bagagens médias', style: 'tableValueWrap' },
                          { text: '15 Pax\n10 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '22 a 26 Pax', style: 'tableValue' },
                          '' // Célula vazia obrigatória por causa do rowSpan
                        ],
                        [
                          {
                            stack: [
                              { text: 'Ônibus Executivo', bold: true, margin: [0, 0, 0, 2] },
                              { text: 'Ar condicionado, TV, DVD, som ambiente, toalete, cinto \nde segurança e reclináveis.' }
                            ],
                            style: 'tableValueWrap'
                          },
                          { text: '44 Pax\n54 bagagens Médias', style: 'tableValueWrap' },
                          { text: '44 Pax\n44 bagagens Grandes', style: 'tableValueWrap' },
                          { text: '44 a 46 Pax', style: 'tableValue' },
                          '' // Célula vazia obrigatória por causa do rowSpan
                        ],
                      ]
                    },
                    layout: {
                      hLineColor: () => '#cccccc',
                      vLineColor: () => '#cccccc',
                      hLineWidth: () => 0.5,
                      vLineWidth: () => 0.5,
                    },
                    margin: [0, 0, 0, 15]
                  },

                ]
              },
              // FRASE LARANJA ABAIXO DA TABELA
              {
                text: 'Não é permitido bagagens dentro do veículo, somente nos bagageiros',
                color: '#E86E1F',
                alignment: 'center',
                bold: true,
                fontSize: 9,
                margin: [0, 0, 0, 15]
              },

              // Observações importantes
              {
                stack: [
                  {
                    table: {
                      widths: ['*'],
                      body: [[{ text: 'OBSERVAÇÕES IMPORTANTES', style: 'mainHeader' }]]
                    },
                    layout: 'noBorders',
                    margin: [0, 0, 0, 10]
                  },
                  { text: '#Orçamento válido por 30 dias e não é garantia de reserva.', style: 'observationItem' },
                  { text: '#Acréscimo de 5% de taxa de serviço sobre o valor total.', style: 'observationItem' },
                  { text: '#Pagamento de acordo com as condições comerciais.', style: 'observationItem' },
                  { text: '#As despesas extras serão cobradas no final do serviço, exceto nos casos não autorizados pelo contratante, que deverão ser informados por escrito no momento da contratação.', style: 'observationItem' },
                  { text: '#O contato do motorista será enviado sempre no final do dia anterior a data do serviço.', style: 'observationItem' },
                  { text: '#Despesas com estacionamento serão cobradas no fechamento dos serviços.', style: 'observationItem' },
                  { text: '#Será cobrada hora extra/parada para atrasos superior à 30 minutos em qualquer serviço com horário definido com o contratante.', style: 'observationItem' },
                  { text: '#Será cobrada Km após o limite da franquia acordada com o contratante.', style: 'observationItem' },
                  { text: '#Para chegadas em aeroportos, daremos como cortesia 01 hora de espera a partir do horário inicialmente previsto do vôo solicitado. Após esse prazo, será cobrado hora extra.', style: 'observationItem' },
                  { text: '#Em caso de qualquer tipo de danos internos no veículo por parte do(s) passageiro(s) que seja necessário higienização do mesmo, o procedimento será cobrado do contratante. Assim como as diárias, caso o veículo precise ficar parado em função do ocorrido.', style: 'observationItem' },
                  { text: '#Os valores de horas extras, km extras, coordenação, receptivo, lunch box, não são comissionados.', style: 'observationItem' },
                  { text: '#Valores não contemplam a taxa de autorização de entrada nas cidades que têm obrigatoriedade.', style: 'observationItem' },
                  { text: '#Os serviços cancelados e/ou alterados, com base na data e horário da reserva, serão cobrados da seguinte forma:', style: 'observationItem' },
                  { text: 'a) com até 48 horas úteis de antecedência - sem cobrança.', style: 'observationSubItem' },
                  { text: 'b) entre 48 e 24 horas úteis de antecedência - 50% do valor acordado.', style: 'observationSubItem' },
                  { text: 'c) menos 24 horas úteis de antecedência - 100% do valor acordado (no-show).', style: 'observationSubItem' },
                  { text: '#Não nos responsabilizamos por objetos deixados no interior dos veículos.', style: 'observationItem' },
                  { text: '#É proibido fumar e/ou consumir bebidas alcoólicas no interior dos veículos.', style: 'observationItem' },
                  { text: '#Transporte de menores até 07 anos de idade, a responsabilidade pelo equipamento (0-1 ano bebê conforto, 1-4 anos cadeirinha, 4-7 anos e meio assento de elevação), será por conta do contratante. Para van, microônibus e ônibus não é permitida a colocação de cadeirinha, bebê conforto ou acento elevado, uma vez que tais veículos não possuem cinto de 3 pontos.', style: 'observationItem' },
                  { text: '#A substituição do veículo em caso de eventual avaria se dará de forma imediata dentro do tempo padrão de até 04hs.', style: 'observationItem' },
                  { text: '#Viagens em rodovia estadual ou federal com Van, Micro-ônibus ou Ônibus, deverá ser enviada lista de passageiros contendo nome completo e RG com órgão emissor ou passaporte (para estrangeiros) em até 72 horas úteis antes da realização do serviço para que possam ser requeridas as autorizações junto aos órgãos competentes. Em caso do não cumprimento, as consequências legais são de responsabilidade do contratante.', style: 'observationItem' },
                  { text: '#Veículos como Van, Micro e Ônibus é necessária a contratação de coordenador para o receptivo em aeroportos ou locais onde não houver um responsável do contratante.', style: 'observationItem' },
                  { text: '#No caso de eventos tradicionais, tais como Carnaval, F-1, Festivais de músicas, etc., os valores podem sofrer alterações.', style: 'observationItem' },
                  { text: '#Telefone: (11) 5564-8700 e email: orcamentos@tgmob.com.br', style: 'observationItem', bold: true },
                ],
                margin: [0, 10, 0, 20]
              }
            ],

            styles: {
              mainHeader: {
                fontSize: 14,
                bold: true,
                color: 'white',
                fillColor: '#E86E1F', // Cor laranja aproximada do print
                alignment: 'center',
                margin: [0, 8, 0, 8] // Dá o "respiro" interno (padding) na faixa
              },
              label: {
                fontSize: 9,
                bold: true,
                color: '#333',
                noWrap: true,
              },
              value: {
                fontSize: 9,
                color: '#333',
                marginLeft: 30
              },
              emergency: {
                fontSize: 9,
                bold: true,
                color: '#000',
                margin: [0, 0, 0, 5] // Pequeno espaço entre as linhas de plantão
              },
              tableHeader: {
                fontSize: 9, // Levemente menor para garantir que caiba em telas menores
                bold: true,
                color: '#333',
                fillColor: '#B2F2BB', // Verde claro pastel idêntico ao print
                alignment: 'center',
                margin: [0, 5, 0, 5]
              },
              tableLabel: {
                fontSize: 9,
                bold: false,
                color: '#333',
                alignment: 'left',
                margin: [1, 3, 1, 3],
                noWrap: true,
              },

              tableValue: {
                fontSize: 9,
                color: '#333',
                alignment: 'left',
                margin: [2, 3, 2, 3],
                noWrap: true,
              },
              tableValueWrap: {
                fontSize: 9,
                color: '#333',
                alignment: 'left',
                margin: [2, 3, 2, 3],
                noWrap: false,
              },
              observationItem: {
                fontSize: 9,
                color: '#333',
                margin: [0, 2, 0, 2],
                alignment: 'justify',
                lineHeight: 1.1 // Melhora a leitura de parágrafos longos
              },
              observationSubItem: {
                fontSize: 9,
                color: '#333',
                margin: [15, 1, 0, 1], // Recuo para os itens a, b, c
              }
            }
          };

          pdfMake.createPdf(documentDefinition).download(docName);



          this.snackbar.success('PDF gerado com sucesso!');
          this.close();
          this.loading = false;
        },
        error: (err: ResponseRequestModel | any) => {
          console.error(err);
          this.snackbar.errorRequest(err);
          this.loading = false;
        }
      });
  }


  downloadExcel() {
    this.loading = true
    this.proposalClientService
      .downloadProposalClientExcel(this.idProposal)
      .subscribe({
        next: (response: any) => {
          // let docName = `${this.item.codigoTg} - ${this.item.nomeCliente} - ${this.item.nomeSubCliente ? this.item.nomeSubCliente + ' - ' : ''} ${this.item.solicitante}`
          // docName = CleanFileName(docName)
          let docName = `${this.item.codigoTg} - ${CleanFileName(this.item.nomeCliente)} - ${this.item.nomeSubCliente ? CleanFileName(this.item.nomeSubCliente) + ' - ' : ''} ${CleanFileName(this.item.solicitante)}`
          downloadBase64File(
            response.data.fileContent,
            docName,
            response.data.type,
          )
          this.snackbar.success(response.message)
          this.close()
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.snackbar.errorRequest(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  private buildItineraryStack(item: any): any[] {
    let stack: any[] = [];

    let origem = null;
    let destino = null;

    if (item.itinerarios && item.itinerarios.length > 0) {
      origem = item.itinerarios.find((i: any) => i.trecho === 'O') || item.itinerarios[0];
      if (item.itinerarios.length > 1) {
        destino = item.itinerarios.find((i: any) => i.trecho === 'D') || item.itinerarios[item.itinerarios.length - 1];
      }
    }

    let hasDestinoInParadas = false;

    if (origem) {
      stack.push({
        columns: [
          { width: 8, canvas: [{ type: 'ellipse', x: 3, y: 5, r1: 2, r2: 2, color: '#4CAF50' }] },
          { text: [{ text: 'Origem: ', color: '#4CAF50', bold: true, fontSize: 7 }, this.getAddressText(origem)], fontSize: 7, alignment: 'left' }
        ]
      });
    }

    if (item.paradas && item.paradas.length > 0) {
      let countParadas = 1;
      item.paradas.forEach((parada: any) => {
        let label = '';
        let color = '';

        if (parada.trecho === 'O') {
          label = 'Origem:';
          color = '#4CAF50';
        } else if (parada.trecho === 'D') {
          label = 'Destino:';
          color = '#F44336';
          hasDestinoInParadas = true;
        } else {
          label = `parada ${countParadas}:`;
          color = '#ff9800';
          countParadas++;
        }

        stack.push({
          columns: [
            { width: 8, canvas: [{ type: 'ellipse', x: 3, y: 5, r1: 2, r2: 2, color: color }] },
            { text: [{ text: label + ' ', color: color, bold: true, fontSize: 7 }, this.getAddressText(parada)], fontSize: 7, alignment: 'left' }
          ]
        });
      });
    }

    if (destino && !hasDestinoInParadas) {
      stack.push({
        columns: [
          { width: 8, canvas: [{ type: 'ellipse', x: 3, y: 5, r1: 2, r2: 2, color: '#F44336' }] },
          { text: [{ text: 'Destino: ', color: '#F44336', bold: true, fontSize: 7 }, this.getAddressText(destino)], fontSize: 7, alignment: 'left' }
        ]
      });
    }

    if (stack.length === 0) {
      const trechoOrigem = item.cidadeOrigem ? `${item.cidadeOrigem}, ${item.estadoOrigem}` : '';
      const trechoDestino = item.cidadeDestino ? `${item.cidadeDestino}, ${item.estadoDestino}` : '';
      stack.push(
        { text: trechoOrigem, fontSize: 8 },
        { text: 'x', fontSize: 8, bold: true, margin: [0, 2, 0, 2], alignment: 'center' },
        { text: trechoDestino, fontSize: 8 }
      );
    }

    return stack;
  }



  private groupConsecutiveItems(itens: any[]): any[][] {
    const result: any[][] = [];
    let currentGroup: any[] = [];
    let currentKey: string | null = null;

    for (const item of itens) {
      const key = JSON.stringify({
        data: item.dataInicio,
        hora: item.horaInicio,
        dataFim: item.dataFinal,
        horaFim: item.horaFinal,
        itinerario: this.buildItineraryStack(item),
        servico: item.descricaoTipoServico,
        detalheServico: item.descricaoServico,
        motorista: item.descricaoTipoMotorista,
        mostrarObsPdf: item.mostrarObsPdf,
        observacao: item.mostrarObsPdf === 'S' ? item.observacao : null
      });

      if (key === currentKey) {
        currentGroup.push(item);
      } else {
        if (currentGroup.length > 0) {
          result.push(currentGroup);
        }
        currentGroup = [item];
        currentKey = key;
      }
    }

    if (currentGroup.length > 0) {
      result.push(currentGroup);
    }

    return result;
  }
}
